import { CompImageCore } from '../core/image/comp'

export const CompImage = CompImageCore
